export default "__VITE_ASSET__CyWJveS7__"